import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as BackstageConstants from '../../../constants';
import * as D from '../../../deps';

// @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
const ArtistSocialLinks = props => {
  const { twitterUrl, isMobileDevice } = props;
  if (!twitterUrl) return null;

  function onTwitterButtonClick() {
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    window.open(twitterUrl, 'twitter').focus();
  }

  return (
    <D.ContentSection
      isSocial={true}
      title={<FormattedMessage {...BackstageConstants.messages.social} />}
      onSocialButtonClick={onTwitterButtonClick}
      disableHover={isMobileDevice}
    />
  );
};

ArtistSocialLinks.propTypes = {
  twitterUrl: PropTypes.string,
  isMobileDevice: PropTypes.bool,
};

export default ArtistSocialLinks;
